import React, { useState } from 'react';
import { FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material'
import { FormControlLabel, Checkbox } from '@mui/material';

import './filterList.css'
import { useSelector } from 'react-redux';

// const origenList = [
//     { id: 'ventas', nombre: 'Gastos directos (negocios)' },
//     { id: 'gastos_internos', nombre: 'Gastos internos' }
// ]

export const FilterList = ({ filters, setFilters }) => {

    const { listaTiposDocumentos } = useSelector(state => state.general)

    // const [anchorEl, setAnchorEl] = useState(null)
    // const [initialFilters, setInitialFilters] = useState(filters)
    const initialFilters = filters
    const [form, setForm] = useState(filters)

    // const handleClose = () => {
    //     setAnchorEl(null);
    // };

    const handleChangeChecked = ({ target }) => {
        setForm({
            ...form,
            [target.name]: target.checked
        })
    }

    const handleChange = ({ target }) => {
        setForm({
            ...form,
            [target.name]: target.value
        })
    }

    const handleClean = () => {
        setFilters(initialFilters)
        setForm(initialFilters)
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        setFilters(form)
    }

    return (
        <div>
            <form onSubmit={handleSubmit} className="row g-2 formFilterList">

                <div className="col-12">
                    <Grid container>
                        <Grid item xs={12}>
                            <Grid container spacing='20' columnSpacing='16' alignItems='center' direction='row'>
                                <Grid item xs={12}>
                                    <FormControl fullWidth size="small">
                                        <InputLabel id="demo-simple-select-label">Tipo Documento</InputLabel>
                                        <Select
                                            label="Tipo Documento"
                                            id="id_tipo_documento"
                                            name="id_tipo_documento"
                                            onChange={handleChange}
                                            value={form?.id_tipo_documento || ''}
                                            className='p-list-capitalize'
                                        >
                                            <MenuItem value='' key=''>Ninguno</MenuItem>
                                            {listaTiposDocumentos.map(item => (
                                                <MenuItem value={item.id} key={item.id} className='p-list-capitalize'>{item.nombre}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </div>

                <div className="col-4 selectSpan">
                    <FormControlLabel
                        className='formControFilterList'
                        control={
                            <Checkbox
                                checked={form?.check_emitida}
                                onChange={handleChangeChecked}
                                name="check_emitida"
                                color='secondary'
                            />
                        }
                        label="Emitidas"
                    />
                </div>
                <div className="col-4 selectSpan">
                    <FormControlLabel
                        className='formControFilterList'
                        control={
                            <Checkbox
                                checked={form?.check_pagada}
                                onChange={handleChangeChecked}
                                name="check_pagada"
                                color="secondary"
                            />
                        }
                        label="Pagadas"
                    />
                </div>
                <div className="col-4 selectSpan">
                    <FormControlLabel
                        className='formControFilterList'
                        control={
                            <Checkbox
                                checked={form?.check_por_emitir}
                                onChange={handleChangeChecked}
                                name="check_por_emitir"
                                color="secondary"
                            />
                        }
                        label="Por emitir"
                    />
                </div>

                <div className="col-4 selectSpan">
                    <FormControlLabel
                        className='formControFilterList'
                        control={
                            <Checkbox
                                checked={form?.check_anulada}
                                onChange={handleChangeChecked}
                                name="check_anulada"
                                color="secondary"
                            />
                        }
                        label="Anulada"
                    />
                </div>

                <div className="col-12 formFilterListButtons">
                    <button
                        type="button" className="btn btn-light buttonLimpiarFiltro"
                        onClick={handleClean}
                    >
                        Limpiar filtros
                    </button>
                    <button
                        type="button" className="btn btn-primary buttonBuscar"
                        onClick={handleSubmit}>
                        Buscar
                    </button>
                </div>
            </form>
        </div>
    )
}
